<div class="container-fluid" *ngIf="planPrimary && planPrimary.maxCoverage ">
  <div class="form-step three-stup">
    <div class="row d-flex">
      <div class="col px-0">
        <img [attr.alt]="vectoralt4" [attr.src]="vectorfilled" />
      </div>
      <div class="col d-flex px-0">
        <div class="separator-blue"></div>
      </div>
      <div class="col px-0">
        <img [attr.alt]="vectoralt4" [attr.src]="vectorfilled" />
      </div>
      <div class="col d-flex px-0">
        <div class="separator-blue"></div>
      </div>
      <div class="col px-0">
        <img [attr.alt]="vectoralt" [attr.src]="vectorUnFilled" />
      </div>
      <!-- <div class="col d-flex px-0">
        <div class="separator-white"></div>
      </div>
      <div class="col px-0">
        <img [attr.alt]="vectoralt" [attr.src]="vectorUnFilled" />
      </div>
      <div class="col d-flex px-0">
        <div class="separator-white"></div>
      </div>
      <div class="col px-0">
        <img [attr.alt]="vectoralt" [attr.src]="vectorUnFilled" />
      </div> -->
    </div>
    <div class="row d-flex">
      <div class="col px-0">
        <span class="letter-style-simulate-steps-grey">Cotizar</span>
      </div>
      <div class="col d-flex px-0">
        <div class="separator-letter-transparent"></div>
      </div>
      <div class="col px-0">
        <span class="letter-style-simulate-steps-blue">Customizar</span>
      </div>
      <div class="col d-flex px-0">
        <div class="separator-letter-transparent"></div>
      </div>
      <div class="col px-0">
        <span class="letter-style-simulate-steps-grey">Pagar</span>
      </div>
      <!-- <div class="col d-flex px-0">
        <div class="separator-letter-transparent"></div>
      </div>
      <div class="col px-0">
        <span class="letter-style-simulate-steps-grey">Pago</span>
      </div>
      <div class="col d-flex px-0">
        <div class="separator-letter-transparent"></div>
      </div>
      <div class="col px-0">
        <span class="letter-style-simulate-steps-grey">Certificado</span>
      </div> -->
    </div>
  </div>
  
<!-- Stup 4 - 5 -->
 <!-- Intro del paso de planes, propuesta 1 (2026-10-18): titulo corto con acento + subtitulo (antes una frase larga en negrita) -->
<div class="q4-intro"><p>Elige un plan. Los opcionales se pueden ampliar o añadir según las coberturas de tu viaje.</p></div>
<div class="mobile-selver-tawer"></div>
<div id="plandetails-shedow">
<div id="plandetails" class="plandetails " [ngClass]="{'fixed-menu': isSticky}">
  
  <!-- Policy Details -->
  <div class="policy-details-toggle">
    <p (click)="toggleSection()" class="clickable-text">
      <span class="">Detalles de Poliza</span>
      <span>Desplegar</span>
    </p>
  <div [class.show]="isSectionVisible" class="toggle-section">
  <div class="policy-details policy-details--v2">
  
    <h4>Tu viaje</h4>
    <div class="policy-info">
      <div class="policy-info-box">
        <span class="policy-info-box-title policy-target-blue"><small>Destino</small>{{geographicalDestination}}</span>
        <a (click)="jumpTpStep(1)" class="info-box-edit" title="Cambiar destino" aria-label="Cambiar destino">
          <img src="/assets/external/edit.png" alt="">
        </a>
      </div>
      <div class="policy-info-box">
        <span class="policy-info-box-title policy-user-blue"><small>Viajeros</small>{{personCount}} {{personCount === 1 ? 'persona' : 'personas'}}</span>
        <a (click)="jumpTpStep(2)" class="info-box-edit" title="Cambiar viajeros" aria-label="Cambiar viajeros">
          <img src="/assets/external/edit.png" alt="">
        </a>
      </div>
      <div class="policy-info-box">
        <span class="policy-info-box-title policy-date-blue"><small>Fechas</small>{{tripRangeLabel || (durationInDays + ' días')}}<em *ngIf="tripRangeLabel">{{durationInDays}} {{durationInDays === 1 ? 'día' : 'días'}}</em></span>
        <a  (click)="jumpTpStep(1)" class="info-box-edit" title="Cambiar fechas" aria-label="Cambiar fechas">
          <img src="/assets/external/edit.png" alt="">
        </a>
      </div>
    </div>
    <div class="button-box">
      <!-- <button type="button" [disabled]="isBusy" class="btn btn-primary" data-bs-toggle="modal"
        data-bs-target="#sendQuoteByEmailModal">Enviar Correo</button> -->
    </div>
  </div>
  </div>
  </div>
  <!-- <div class="policy-details">
    
    <h4>Policy Details</h4>
    <div class="policy-info">
      <div class="policy-info-box">
        <span class="policy-info-box-title policy-target-blue">Destino North America</span>
        <a (click)="jumpTpStep(3)" class="info-box-edit">
          <img src="/assets/external/edit.png" alt="edit">
        </a>
      </div>
      <div class="policy-info-box">
        <span class="policy-info-box-title policy-user-blue">2 Personas</span>
        <a (click)="jumpTpStep(2)" class="info-box-edit">
          <img src="/assets/external/edit.png" alt="edit">
        </a>
      </div>
      <div class="policy-info-box">
        <span class="policy-info-box-title policy-date-blue">6 días</span>
        <a (click)="jumpTpStep(2)" class="info-box-edit">
          <img src="/assets/external/edit.png" alt="edit">
        </a>
      </div>
    </div>
    <div class="button-box">
      <button type="button" [disabled]="isBusy" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#sendQuoteByEmailModal">Enviar Correo</button>
    </div>
  </div> -->
  <div class="plans-main-section">
    <div class="plans-main-box all-plans-section">
      <!-- light Update -->
      <div class="planupadte-box primary-plan">
        <h4>Light</h4>
        <div class="plan-price">
          <h2>{{planPrimary.price | currency:'USD':'symbol' }}</h2>
          <span class="blue-text">Cobertura por {{maximumCoverage[0].name}}</span>
          <span class="gray-text">Precio expresado en dólares (EE. UU.)</span>
          <div class="plan-price-info">
            <div class="plan-price-info-box">
              <span class="plan-price-info-box-title">Coberturas Opcionales Seleccionadas</span>
              <div class="plan-price-value-table"
                [class.plan-price-value-table-active]="(planPrimary.preexistingMedicalConditions.value == true && planPrimary.preexistingMedicalConditions.ownerRate > 0) || (planPrimary.preexistingMedicalConditions.value == true && planPrimary.preexistingMedicalConditions.dependentsRate > 0)">
                <span>Preexistencias</span>
                <span class="text-bold">
                  <span *ngIf="planPrimary.preexistingMedicalConditions.value == false" class="text-center">
                    No
                  </span>
                  <span
                    *ngIf="planPrimary.preexistingMedicalConditions.value == true && planPrimary.preexistingMedicalConditions.ownerRate > 0" class="text-center">
                    Titular
                  </span>
                  <span
                    *ngIf="planPrimary.preexistingMedicalConditions.value == true && planPrimary.preexistingMedicalConditions.dependentsRate > 0" class="text-center">

                    Dep.{{planPrimary.preexistingMedicalConditions.applicableDependentsCount}}
                  </span>
                </span>
                <span>
                  <span *ngIf="planPrimary.preexistingMedicalConditions.value == false">
                    + {{0 | currency:'USD':'symbol' }}
                  </span>
                  <span
                    *ngIf="planPrimary.preexistingMedicalConditions.value == true && planPrimary.preexistingMedicalConditions.ownerRate > 0">
                    + {{planPrimary.preexistingMedicalConditions.ownerRate | currency:'USD':'symbol'}}
                  </span>
                  <span
                    *ngIf="planPrimary.preexistingMedicalConditions.value == true && planPrimary.preexistingMedicalConditions.dependentsRate > 0">

                    + {{planPrimary.preexistingMedicalConditions.dependentsRate | currency:'USD':'symbol'}}
                  </span>
                </span>
              </div>
              <div class="plan-price-value-table"
                [class.plan-price-value-table-active]="(planPrimary.sportPractice.value == true && planPrimary.sportPractice.ownerRate > 0) || (planPrimary.sportPractice.value == true && planPrimary.sportPractice.dependentsRate > 0)">
                <span>Deportes</span>
                <span class="text-bold">
                  <span *ngIf="planPrimary.sportPractice.value == false" class="text-center">
                    No
                  </span>
                  <span *ngIf="planPrimary.sportPractice.value == true && planPrimary.sportPractice.ownerRate > 0" class="text-center">
                    Titular
                  </span>
                  <span *ngIf="planPrimary.sportPractice.value == true && planPrimary.sportPractice.dependentsRate > 0" class="text-center">

                    Dep.{{planPrimary.sportPractice.applicableDependentsCount}}
                  </span>
                </span>
                <span>
                  <span *ngIf="planPrimary.sportPractice.value == false">
                    + {{0 | currency:'USD':'symbol' }}
                  </span>
                  <span *ngIf="planPrimary.sportPractice.value == true && planPrimary.sportPractice.ownerRate > 0">
                    + {{planPrimary.sportPractice.ownerRate | currency:'USD':'symbol' }}
                  </span>
                  <span *ngIf="planPrimary.sportPractice.value == true && planPrimary.sportPractice.dependentsRate > 0">

                    + {{planPrimary.sportPractice.dependentsRate | currency:'USD':'symbol' }}
                  </span>
                </span>
              </div>
              <!-- <div class="plan-price-value-table"
                [class.plan-price-value-table-active]="planPrimary.maxCoverage && planPrimary.maxCoverage.ownerRate > 0 || planPrimary.maxCoverage.dependentsRate > 0">
                <span>Cobertura Máxima</span>
                <span class="text-bold">
                  <span *ngIf="planPrimary.maxCoverage.ownerRate > 0" class="text-center">
                    Titular
                  </span>
                  <span *ngIf="planPrimary.maxCoverage.dependentsRate > 0" class="text-center">

                    Dep.{{planPrimary.maxCoverage.applicableDependentsCount}}
                  </span>
                </span>
                <span>
                  <span *ngIf="planPrimary.maxCoverage.ownerRate > 0">
                    + {{planPrimary.maxCoverage.ownerRate | currency:'USD':'symbol' }}
                  </span>
                  <span *ngIf="planPrimary.maxCoverage.dependentsRate > 0">

                    + {{planPrimary.maxCoverage.dependentsRate | currency:'USD':'symbol' }}
                  </span>
                </span>
              </div> -->
              <div class="plan-price-value-table"
                [class.plan-price-value-table-active]="planPrimary.cancellationDueToCatastrophicTrip.rate != 0">
                <span>Cancelación</span>
                <span class="text-bold text-center">{{selectedCancelTravel.name}}</span>
                <span>+ {{planPrimary.cancellationDueToCatastrophicTrip.rate ?? 0 | currency:'USD':'symbol'}}</span>
              </div>
              <div class="plan-price-value-table"
                [class.plan-price-value-table-active]="(planPrimary.futureMom.value == true && planPrimary.futureMom.ownerRate > 0 || planPrimary.futureMom.value == true && planPrimary.futureMom.dependentsRate > 0)">
                <span>Futura Mamá</span>
                <span class="text-bold">
                  <span *ngIf="planPrimary.futureMom.value == false" class="text-center">
                    No
                  </span>
                  <span *ngIf="planPrimary.futureMom.value == true && planPrimary.futureMom.ownerRate > 0" class="text-center">
                    Titular
                  </span>
                  <span *ngIf="planPrimary.futureMom.value == true && planPrimary.futureMom.dependentsRate > 0" class="text-center">

                    Dep. {{planPrimary.futureMom.applicableDependentsCount}}
                  </span>
                </span>
                <span>
                  <span *ngIf="planPrimary.futureMom.value == false">
                    + {{0 | currency:'USD':'symbol' }}
                  </span>
                  <span *ngIf="planPrimary.futureMom.value == true && planPrimary.futureMom.ownerRate > 0">
                    + {{planPrimary.futureMom.ownerRate | currency:'USD':'symbol' }}
                  </span>
                  <span *ngIf="planPrimary.futureMom.value == true && planPrimary.futureMom.dependentsRate > 0">

                    + {{planPrimary.futureMom.dependentsRate | currency:'USD':'symbol' }}
                  </span>
                </span>
              </div>
              <div class="plan-price-value-table" [class.plan-price-value-table-active]="(planPrimary.pets.rate != 0)">
                <span>Mascotas</span>
                <span class="text-bold text-center">{{selectedAssistPet.name}}</span>
                <span>+ {{planPrimary.pets.rate ?? 0 | currency:'USD':'symbol'}}</span>
              </div>
              <div class="plan-price-value-table"
                [class.plan-price-value-table-active]="planPrimary.legalVipAssistance.value ">
                <span>Asistencia Legal VIP</span>
                <span class="text-bold text-center">{{selectedLegalAssist.name}}</span>
                <span>+ {{planPrimary.legalVipAssistance.rate ?? 0 | currency:'USD':'symbol'}}</span>
              </div>
            </div>
          </div>
          <div class="button-box">
            <button class="btn btn-primary" (click)="openModalSendEmail('Primary')">Enviar por Correo</button>
            <button class="btn btn-primary blue-btn" [class.is-busy]="buyingPlan === 'Primary'" [disabled]="!!buyingPlan" (click)="selectPlan('Primary')">{{ buyingPlan === 'Primary' ? 'Procesando…' : 'Comprar Plan' }}</button><p class="buy-error" *ngIf="buyError === 'Primary'">No se pudo continuar. Inténtalo de nuevo.</p>
          </div>
        </div>
        
      </div>
      <!-- standard Update -->
      <div class="planupadte-box standard-plan">
        <h4>Standard</h4>
        <div class="plan-price">
          <h2>{{planStandard.price | currency:'USD':'symbol' }}</h2>
          <span class="blue-text">Cobertura por {{maximumCoverage[1].name}}</span>
          <span class="gray-text">Precio expresado en dólares (EE. UU.)</span>
          <div class="plan-price-info">
            <div class="plan-price-info-box">
              <span class="plan-price-info-box-title">Coberturas Opcionales Seleccionadas</span>
              <div class="plan-price-value-table"
                [class.plan-price-value-table-active]="(planStandard.preexistingMedicalConditions.value == true && planStandard.preexistingMedicalConditions.ownerRate > 0) || (planStandard.preexistingMedicalConditions.value == true && planStandard.preexistingMedicalConditions.dependentsRate > 0)">
                <span>Preexistencias</span>
                <span class="text-bold">
                  <span *ngIf="planStandard.preexistingMedicalConditions.value == false" class="text-center">
                    No
                  </span>
                  <span
                    *ngIf="planStandard.preexistingMedicalConditions.value == true && planStandard.preexistingMedicalConditions.ownerRate > 0" class="text-center">
                    Titular
                  </span>
                  <span
                    *ngIf="planStandard.preexistingMedicalConditions.value == true && planStandard.preexistingMedicalConditions.dependentsRate > 0" class="text-center">

                    Dep.{{planStandard.preexistingMedicalConditions.applicableDependentsCount}}
                  </span>
                </span>
                <span>
                  <span *ngIf="planStandard.preexistingMedicalConditions.value == false">
                    + {{0 | currency:'USD':'symbol' }}
                  </span>
                  <span
                    *ngIf="planStandard.preexistingMedicalConditions.value == true && planStandard.preexistingMedicalConditions.ownerRate > 0">
                    + {{planStandard.preexistingMedicalConditions.ownerRate | currency:'USD':'symbol'}}
                  </span>
                  <span
                    *ngIf="planStandard.preexistingMedicalConditions.value == true && planStandard.preexistingMedicalConditions.dependentsRate > 0">

                    + {{planStandard.preexistingMedicalConditions.dependentsRate | currency:'USD':'symbol'}}
                  </span>
                </span>
              </div>
              <div class="plan-price-value-table"
                [class.plan-price-value-table-active]="(planStandard.sportPractice.value == true && planStandard.sportPractice.ownerRate > 0) || (planStandard.sportPractice.value == true && planStandard.sportPractice.dependentsRate > 0)">
                <span>Deportes</span>
                <span class="text-bold">
                  <span *ngIf="planStandard.sportPractice.value == false" class="text-center">
                    No
                  </span>
                  <span *ngIf="planStandard.sportPractice.value == true && planStandard.sportPractice.ownerRate > 0" class="text-center">
                    Titular
                  </span>
                  <span *ngIf="planStandard.sportPractice.value == true && planStandard.sportPractice.dependentsRate > 0" class="text-center">

                    Dep.{{planStandard.sportPractice.applicableDependentsCount}}
                  </span>
                </span>
                <span>
                  <span *ngIf="planStandard.sportPractice.value == false">
                    + {{0 | currency:'USD':'symbol' }}
                  </span>
                  <span *ngIf="planStandard.sportPractice.value == true && planStandard.sportPractice.ownerRate > 0">
                    + {{planStandard.sportPractice.ownerRate | currency:'USD':'symbol' }}
                  </span>
                  <span *ngIf="planStandard.sportPractice.value == true && planStandard.sportPractice.dependentsRate > 0">

                    + {{planStandard.sportPractice.dependentsRate | currency:'USD':'symbol' }}
                  </span>
                </span>
              </div>
              <div class="plan-price-value-table"
                [class.plan-price-value-table-active]="planStandard.cancellationDueToCatastrophicTrip.rate != 0">
                <span>Cancelación</span>
                <span class="text-bold text-center">{{selectedCancelTravel.name}}</span>
                <span>+ {{planStandard.cancellationDueToCatastrophicTrip.rate ?? 0 | currency:'USD':'symbol'}}</span>
              </div>
              <div class="plan-price-value-table"
                [class.plan-price-value-table-active]="(planStandard.futureMom.value == true && planStandard.futureMom.ownerRate > 0 || planStandard.futureMom.value == true && planStandard.futureMom.dependentsRate > 0)">
                <span>Futura Mamá</span>
                <span class="text-bold">
                  <span *ngIf="planStandard.futureMom.value == false" class="text-center">
                    No
                  </span>
                  <span *ngIf="planStandard.futureMom.value == true && planStandard.futureMom.ownerRate > 0"  class="text-center">
                    Titular
                  </span>
                  <span *ngIf="planStandard.futureMom.value == true && planStandard.futureMom.dependentsRate > 0"  class="text-center">

                    Dep. {{planStandard.futureMom.applicableDependentsCount}}
                  </span>
                </span>
                <span>
                  <span *ngIf="planStandard.futureMom.value == false">
                    + {{0 | currency:'USD':'symbol' }}
                  </span>
                  <span *ngIf="planStandard.futureMom.value == true && planStandard.futureMom.ownerRate > 0">
                    + {{planStandard.futureMom.ownerRate | currency:'USD':'symbol' }}
                  </span>
                  <span *ngIf="planStandard.futureMom.value == true && planStandard.futureMom.dependentsRate > 0">

                    + {{planStandard.futureMom.dependentsRate | currency:'USD':'symbol' }}
                  </span>
                </span>
              </div>
              <!-- <div class="plan-price-value-table"
                [class.plan-price-value-table-active]="planStandard.maxCoverage.ownerRate > 0 || planStandard.maxCoverage.dependentsRate > 0">
                <span>Cobertura Máxima</span>
                <span class="text-bold">
                  <span *ngIf="planStandard.maxCoverage.ownerRate > 0" class="text-center">
                    Titular
                  </span>
                  <span *ngIf="planStandard.maxCoverage.dependentsRate > 0" class="text-center">

                    Dep.{{planStandard.maxCoverage.applicableDependentsCount}}
                  </span>
                </span>
                <span>
                  <span *ngIf="planStandard.maxCoverage.ownerRate > 0">
                    + {{planStandard.maxCoverage.ownerRate | currency:'USD':'symbol' }}
                  </span>
                  <span *ngIf="planStandard.maxCoverage.dependentsRate > 0">

                    + {{planStandard.maxCoverage.dependentsRate | currency:'USD':'symbol' }}
                  </span>
                </span>
              </div> -->
              <div class="plan-price-value-table" [class.plan-price-value-table-active]="(planStandard.pets.rate != 0)">
                <span>Mascotas</span>
                <span class="text-bold text-center">{{selectedAssistPet.name}}</span>
                <span>+ {{planStandard.pets.rate ?? 0 | currency:'USD':'symbol'}}</span>
              </div>
              <div class="plan-price-value-table"
                [class.plan-price-value-table-active]="planStandard.legalVipAssistance.value ">
                <span>Asistencia Legal VIP</span>
                <span class="text-bold text-center">{{selectedLegalAssist.name}}</span>
                <span>+ {{planStandard.legalVipAssistance.rate ?? 0 | currency:'USD':'symbol'}}</span>
              </div>
            </div>
          </div>
          <div class="button-box">
            <button class="btn btn-primary" (click)="openModalSendEmail('Standard')">Enviar por Correo</button>
            <button class="btn btn-primary blue-btn" [class.is-busy]="buyingPlan === 'Standard'" [disabled]="!!buyingPlan" (click)="selectPlan('Standard')">{{ buyingPlan === 'Standard' ? 'Procesando…' : 'Comprar Plan' }}</button><p class="buy-error" *ngIf="buyError === 'Standard'">No se pudo continuar. Inténtalo de nuevo.</p>
          </div>
        </div>
      </div>
      <!-- primary Update -->
      <div class="planupadte-box light-plan">
        <h4>Superior</h4>
        <div class="plan-price">
          <h2>{{planLight.price | currency:'USD':'symbol' }}</h2>
          <span class="blue-text">Cobertura por {{maximumCoverage[2].name}}</span>
          <span class="gray-text">Precio expresado en dólares (EE. UU.)</span>
          <div class="plan-price-info">
            <div class="plan-price-info-box">
              <span class="plan-price-info-box-title">Coberturas Opcionales Seleccionadas</span>
              <div class="plan-price-value-table"
                [class.plan-price-value-table-active]="(planLight.preexistingMedicalConditions.value == true && planLight.preexistingMedicalConditions.ownerRate > 0) || (planLight.preexistingMedicalConditions.value == true && planLight.preexistingMedicalConditions.dependentsRate > 0)">
                <span>Preexistencias</span>
                <span class="text-bold">
                  <span *ngIf="planLight.preexistingMedicalConditions.value == false"  class="text-center">
                    No
                  </span>
                  <span
                    *ngIf="planLight.preexistingMedicalConditions.value == true && planLight.preexistingMedicalConditions.ownerRate > 0"  class="text-center">
                    Titular
                  </span>
                  <span
                    *ngIf="planLight.preexistingMedicalConditions.value == true && planLight.preexistingMedicalConditions.dependentsRate > 0"  class="text-center">

                    Dep.{{planLight.preexistingMedicalConditions.applicableDependentsCount}}
                  </span>
                </span>
                <span>
                  <span *ngIf="planLight.preexistingMedicalConditions.value == false">
                    + {{0 | currency:'USD':'symbol' }}
                  </span>
                  <span
                    *ngIf="planLight.preexistingMedicalConditions.value == true && planLight.preexistingMedicalConditions.ownerRate > 0">
                    + {{planLight.preexistingMedicalConditions.ownerRate | currency:'USD':'symbol'}}
                  </span>
                  <span
                    *ngIf="planLight.preexistingMedicalConditions.value == true && planLight.preexistingMedicalConditions.dependentsRate > 0">

                    + {{planLight.preexistingMedicalConditions.dependentsRate | currency:'USD':'symbol'}}
                  </span>
                </span>
              </div>
              <div class="plan-price-value-table"
                [class.plan-price-value-table-active]="(planLight.sportPractice.value == true && planLight.sportPractice.ownerRate > 0) || (planLight.sportPractice.value == true && planLight.sportPractice.dependentsRate > 0)">
                <span>Deportes</span>
                <span class="text-bold">
                  <span *ngIf="planLight.sportPractice.value == false"  class="text-center">
                    No
                  </span>
                  <span *ngIf="planLight.sportPractice.value == true && planLight.sportPractice.ownerRate > 0"  class="text-center">
                    Titular
                  </span>
                  <span *ngIf="planLight.sportPractice.value == true && planLight.sportPractice.dependentsRate > 0"  class="text-center">

                    Dep.{{planLight.sportPractice.applicableDependentsCount}}
                  </span>
                </span>
                <span>
                  <span *ngIf="planLight.sportPractice.value == false">
                    + {{0 | currency:'USD':'symbol' }}
                  </span>
                  <span *ngIf="planLight.sportPractice.value == true && planLight.sportPractice.ownerRate > 0">
                    + {{planLight.sportPractice.ownerRate | currency:'USD':'symbol' }}
                  </span>
                  <span *ngIf="planLight.sportPractice.value == true && planLight.sportPractice.dependentsRate > 0">

                    + {{planLight.sportPractice.dependentsRate | currency:'USD':'symbol' }}
                  </span>
                </span>
              </div>
              <div class="plan-price-value-table"
                [class.plan-price-value-table-active]="planLight.cancellationDueToCatastrophicTrip.rate != 0">
                <span>Cancelación</span>
                <span class="text-bold text-center">{{selectedCancelTravel.name}}</span>
                <span>+ {{planLight.cancellationDueToCatastrophicTrip.rate ?? 0 | currency:'USD':'symbol'}}</span>
              </div>
              <!-- <div class="plan-price-value-table"
                [class.plan-price-value-table-active]="planLight.maxCoverage.ownerRate > 0 || planLight.maxCoverage.dependentsRate > 0">
                <span>Cobertura Máxima</span>
                <span class="text-bold">
                  <span *ngIf="planLight.maxCoverage.ownerRate > 0"  class="text-center">
                    Titular
                  </span>
                  <span *ngIf="planLight.maxCoverage.dependentsRate > 0"  class="text-center">
                    Dep.{{planLight.maxCoverage.applicableDependentsCount}}
                  </span>
                </span>
                <span>
                  <span *ngIf="planLight.maxCoverage.ownerRate > 0">
                    + {{planLight.maxCoverage.ownerRate | currency:'USD':'symbol' }}
                  </span>
                  <span *ngIf="planLight.maxCoverage.dependentsRate > 0">

                    + {{planLight.maxCoverage.dependentsRate | currency:'USD':'symbol' }}
                  </span>
                </span>
              </div> -->
              <div class="plan-price-value-table"
                [class.plan-price-value-table-active]="(planLight.futureMom.value == true && planLight.futureMom.ownerRate > 0 || planLight.futureMom.value == true && planLight.futureMom.dependentsRate > 0)">
                <span>Futura Mamá</span>
                <span class="text-bold">
                  <span *ngIf="planLight.futureMom.value == false" class="text-center">
                    No
                  </span>
                  <span *ngIf="planLight.futureMom.value == true && planLight.futureMom.ownerRate > 0"  class="text-center">
                    Titular
                  </span>
                  <span *ngIf="planLight.futureMom.value == true && planLight.futureMom.dependentsRate > 0"  class="text-center">

                    Dep. {{planLight.futureMom.applicableDependentsCount}}
                  </span>
                </span>
                <span>
                  <span *ngIf="planLight.futureMom.value == false">
                    + {{0 | currency:'USD':'symbol' }}
                  </span>
                  <span *ngIf="planLight.futureMom.value == true && planLight.futureMom.ownerRate > 0">
                    + {{planLight.futureMom.ownerRate | currency:'USD':'symbol' }}
                  </span>
                  <span *ngIf="planLight.futureMom.value == true && planLight.futureMom.dependentsRate > 0">

                    + {{planLight.futureMom.dependentsRate | currency:'USD':'symbol' }}
                  </span>
                </span>
              </div>
              <div class="plan-price-value-table" [class.plan-price-value-table-active]="(planLight.pets.rate != 0)">
                <span>Mascotas</span>
                <span class="text-bold text-center">{{selectedAssistPet.name}}</span>
                <span>+ {{planLight.pets.rate ?? 0 | currency:'USD':'symbol'}}</span>
              </div>
              
              <div class="plan-price-value-table"
                [class.plan-price-value-table-active]="planLight.legalVipAssistance.value ">
                <span>Asistencia Legal VIP</span>
                <span class="text-bold text-center">{{selectedLegalAssist.name}}</span>
                <span>+ {{planLight.legalVipAssistance.rate ?? 0 | currency:'USD':'symbol'}}</span>
              </div>
            </div>
          </div>
          <div class="button-box">
            <button class="btn btn-primary" (click)="openModalSendEmail('Light')">Enviar por Correo</button>
            <button class="btn btn-primary blue-btn" [class.is-busy]="buyingPlan === 'Light'" [disabled]="!!buyingPlan" (click)="selectPlan('Light')">{{ buyingPlan === 'Light' ? 'Procesando…' : 'Comprar Plan' }}</button><p class="buy-error" *ngIf="buyError === 'Light'">No se pudo continuar. Inténtalo de nuevo.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</div>
<div class="stups-accordion">
  <p class="options-heading-visible-on-mobile web-none"><strong>Coberturas opcionales</strong><small class="opt-sub">beneficios opcionales flexibles por asegurado</small></p>
  <p-accordion class="w-full" [(activeIndex)]="activeCoverageTab">
    <p-accordionTab [class.plan-added]="planPrimary.preexistingMedicalConditions.value == true">
      <ng-template pTemplate="header">
        <div class="d-flex justify-content-between w-100">
          <span class="text-white-short-style">Condiciones Médicas Preexistente</span>
          <span class="blue-text">{{ planPrimary.preexistingMedicalConditions.value == true ? 'Añadido' : 'Añadir' }} 
            <img src="/assets/external/gray-minas.svg" alt="open">
          </span>
        </div>
      </ng-template>
      <div class="p-style-accordion">
        <div class="plan-info-text">Límite máximo: 30% de la cobertura máxima seleccionada bajo el plan, sin exceder US $30.000</div>
          <app-quote-per-member-selector *ngIf="isInitialized" [optionName]="'preexistingMedicalConditions'"
                  [model]="quoteService.quoteRateModel.preexistingMedicalConditions"
                  [depenentsCount]="personCount"
                  (optionChanged)="onOptionalBenefitChanged($event)">
                </app-quote-per-member-selector>
       
      </div>
    </p-accordionTab>
    <p-accordionTab [class.plan-added]="planPrimary.sportPractice.value == true">
      <ng-template pTemplate="header">
        <div class="d-flex justify-content-between w-100">
          <span class="text-white-short-style">Deportes Peligrosos, Profesionales y Amateur</span>
          <span class="blue-text">{{ planPrimary.sportPractice.value == true ? 'Añadido' : 'Añadir' }} 
            <img src="/assets/external/gray-minas.svg" alt="open">
          </span>
        </div>
      </ng-template>
      <div class="p-style-accordion">
        <div class="plan-info-text">Servicios de asistencia médica para la estabilización y tratamiento de una emergencia médica resultado de su participación en deportes peligrosos, profesionales o amateur.
          El límite de este beneficio será la cobertura máxima seleccionada, sin exceder US $100,000.</div>
          <app-quote-per-member-selector [optionName]="'sportPractice'"
                  [model]="quoteService.quoteRateModel.sportPractice"
                  [depenentsCount]="personCount"
                  (optionChanged)="onOptionalBenefitChanged($event)">
                </app-quote-per-member-selector>
   
      </div>
    </p-accordionTab>
    <p-accordionTab [class.plan-added]="planPrimary.cancellationDueToCatastrophicTrip.rate != 0">
      <ng-template pTemplate="header">
        <div class="d-flex justify-content-between w-100">
          <span class="text-white-short-style">Cancelación e interrupción de viaje</span>
          <span class="blue-text">{{ planPrimary.cancellationDueToCatastrophicTrip.rate != 0 ? 'Añadido' : 'Añadir' }}  
            <img src="/assets/external/gray-minas.svg" alt="open">
          </span>
        </div>
      </ng-template>
      <div class="p-style-accordion">
        <div class="plan-info-text">Indemnización por la pérdida de los gastos prepagados, no reembolsables, en relación con una cancelación o interrupción inevitable del viaje por una causa cubierta.</div>
        <div class="plan-info-details">
          <div class="plan-info-details-box" *ngFor="let category of cancelTravel">
            <span class="plan-info-details-box-title">{{ category.name }}</span>
            <span class="plan-info-details-box-value" (click)="onSelectedCancelTravelChange(category)" [class.active]="selectedCancelTravel.key == category.key">
              <!-- <p-radioButton [inputId]="category.key" name="category" [value]="category"
              [(ngModel)]="selectedCancelTravel"
              (ngModelChange)="onSelectedCancelTravelChange($event)"></p-radioButton> -->
            </span>
          </div>
         
        </div>
      </div>
    </p-accordionTab>
    <p-accordionTab [class.plan-added]="planPrimary.futureMom.value == true">
      <ng-template pTemplate="header">
        <div class="d-flex justify-content-between w-100">
          <span class="text-white-short-style">Futura Mamá</span>
          <span class="blue-text">{{ planPrimary.futureMom.value == true ? 'Añadido' : 'Añadir' }} 
            <img src="/assets/external/gray-minas.svg" alt="open">
          </span>
        </div>
      </ng-template>
      <div class="p-style-accordion">
        <div class="plan-info-text">Servicios de asistencia médica para la estabilización de una emergencia médica por enfermedad o accidente producto de su embarazo. Beneficio se adquiere entre 12 y 32 semanas de embarazo y cuando la edad de la solicitante sea entre 18 y 40 años. Límite Máximo: Hasta US $10.000</div>
          <app-quote-per-member-selector *ngIf="isInitialized" [optionName]="'futureMom'"
                  [model]="quoteService.quoteRateModel.futureMom" [depenentsCount]="personCount"
                  (optionChanged)="onOptionalBenefitChanged($event)">
                </app-quote-per-member-selector>
      </div>
    </p-accordionTab>
    <p-accordionTab [class.plan-added]="planPrimary.pets.rate != 0">
      <ng-template pTemplate="header">
        <div class="d-flex justify-content-between w-100">
          <span class="text-white-short-style">Asistencia para Mascotas</span>
          <span class="blue-text">{{ planPrimary.pets.rate != 0 ? 'Añadido' : 'Añadir' }} 
            <img src="/assets/external/gray-minas.svg" alt="open">
          </span>
        </div>
      </ng-template>
      <div class="p-style-accordion">
        <div class="plan-info-text">Servicios de asistencia médica para la estabilización de una emergencia médica por enfermedad no preexistente o accidente de la mascota.
          Límite Máximo $1.000 por mascota. Máximo 3 (aplica para perros y gatos únicamente)</div>
        <div class="plan-info-details">
          <div class="plan-info-details-box">
            <span class="plan-info-details-box-title">Número de Mascotas</span>
            <div class="plan-info-details-box-value d-flex align-items-center plan-info-details-increment">
              <div class="pr-4 w-50px">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="red" class="img-cursor-pointer"
                  xmlns="http://www.w3.org/2000/svg"
                  (click)="onSelectedAssistPetCounter('plus')"
                  >
                  <path
                    d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM15 11H11V15H9V11H5V9H9V5H11V9H15V11Z"
                    fill="#2828E0" />
                </svg>
              </div>
              <span class="text-style-blue pr-4 w-50px" style="line-height:27px;">
                <span>{{selectedAssistPet.name}}</span>
              </span>
              <div class="pr-2">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" class="img-cursor-pointer"
                  xmlns="http://www.w3.org/2000/svg"
                  (click)="onSelectedAssistPetCounter('minus')"
                  >
                  <path
                    d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM15 11H5V9H15V11Z"
                    fill="#E6E8EB" />
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
    </p-accordionTab>
    <p-accordionTab [class.plan-added]="planPrimary.legalVipAssistance.value">
      <ng-template pTemplate="header">
        <div class="d-flex justify-content-between w-100">
          <span class="text-white-short-style">Asistencia Legal VIP</span>
          <span class="blue-text">{{ planPrimary.legalVipAssistance.value ? 'Añadido' : 'Añadir' }} 
            <img src="/assets/external/gray-minas.svg" alt="open">
          </span>
        </div>
      </ng-template>
      <div class="p-style-accordion">
        <div class="plan-info-text">Asistencia legal durante su viaje con apoyo local. </div>
        <div class="plan-info-details">
          <div class="plan-info-details-boxXX p-0">
            <!-- <div *ngFor="let category of legalAssist" class="plan-info-details-box field-checkbox" style="padding: 5px;">
              <label [for]="category.key" class="ml-2" style="margin-bottom: 0.1rem;">{{ category.name }}</label>
              <p-radioButton [inputId]="category.key" name="category" [value]="category"
                [(ngModel)]="selectedLegalAssist" (ngModelChange)="onSelectedLegalAssistChange($event)"></p-radioButton>
              
            </div> -->
            </div>
            <button type="button" class="btn continue-btn-steps py-3" 
              [class.btn-primary]="selectedLegalAssist.key == 1"
              [class.btn-is-selected]="selectedLegalAssist.key == 1"
              (click)="onSelectedLegalAssistChange(legalAssist[selectedLegalAssist.key == 1 ? 0 : 1])"
            >{{selectedLegalAssist.key == 1 ? 'Añadido' : 'Añadir'}}</button>
          
        </div>
      </div>
    </p-accordionTab>
  </p-accordion>
</div>
<div class="plan-full-info">
  <div class="plan-full-info-row">
    <div class="plan-full-info-box basic-plan">
      <p>Servicios hospitalarios para la estabilización y tratamiento de una Emergencia incluyendo, pero sin estar limitados a:</p>
      <ul>
        <li>Servicios de emergencia para pacientes internos y ambulatorios</li>
        <li>Anestesia, transfusión de sangre, oxígeno</li>
        <li>Yesos, vendajes, cabestrillos, etc.</li>
        <li>Telemedicina</li>
      </ul>
    </div>
    <div class="plan-full-info-box primary-plan">
      <p>Límite máximo por persona por periodo de vigencia: USD $50,000 Los servicios solo serán provistos hasta que cese la Emergencia.</p>
    </div>
    <div class="plan-full-info-box standard-plan">
      <p>Límite máximo por persona por periodo de vigencia: USD $100,000 Los servicios solo serán provistos hasta que cese la Emergencia.</p>
    </div>
    <div class="plan-full-info-box light-plan">
      <p>Límite máximo por persona por periodo de vigencia: USD $ 250,000 Los servicios solo serán provistos hasta que cese la Emergencia.</p>
    </div>
  </div>
  <div class="plan-full-info-row">
    <div class="plan-full-info-box basic-plan">
      <p>Asistencia Médica por Condiciones médicas preexistentes</p>

    </div>
    <div class="plan-full-info-box primary-plan">
      <p class="text-bold text-number">US $1,000</p>
    </div>
    <div class="plan-full-info-box standard-plan">
      <p class="text-bold text-number">US $1,500</p>
    </div>
    <div class="plan-full-info-box light-plan">
      <p class="text-bold text-number">US $4,500</p>
    </div>
  </div>
  <div class="plan-full-info-row">
    <div class="plan-full-info-box basic-plan">
      <p><span class="text-bold"> Covid‐19 ‐ Coronavirus. </span><br>
       Prueba de detección médicamente necesarias, máximo 2 pruebas. 
Excluye la primera prueba de detección realizada a su llegada al país de destino.</p>

    </div>
    <div class="plan-full-info-box primary-plan">
      <p>Hasta el límite máximo indicado en el Inciso N°.1. (arriba)</p>
    </div>
    <div class="plan-full-info-box standard-plan">
      <p>Hasta el límite máximo indicado en el Inciso N°.1. (arriba)</p>
    </div>
    <div class="plan-full-info-box light-plan">
      <p>Hasta el límite máximo indicado en el Inciso N°.1. (arriba)</p>
    </div>
  </div>
  <div class="plan-full-info-row">
    <div class="plan-full-info-box basic-plan">
      <p>Asistencia Médica por Deportes Recreacionales</p>
    </div>
    <div class="plan-full-info-box primary-plan">
      <p>100%</p>
    </div>
    <div class="plan-full-info-box standard-plan">
      <p>100%</p>
    </div>
    <div class="plan-full-info-box light-plan">
      <p>100%</p>
    </div>
  </div>
  <div class="plan-full-info-row">
    <div class="plan-full-info-box basic-plan">
      <p>Servicios de médicos y especialistas para el cuidado, tratamiento o cirugía requeridos por una emergencia</p>

    </div>
    <div class="plan-full-info-box primary-plan">
      <p >100%</p>
    </div>
    <div class="plan-full-info-box standard-plan">
      <p >100%</p>
    </div>
    <div class="plan-full-info-box light-plan">
      <p >100%</p>
    </div>
  </div>
  <div class="plan-full-info-row">
    <div class="plan-full-info-box basic-plan">
      <p>Medicamentos prescritos requeridos por una emergencia</p>
    </div>
    <div class="plan-full-info-box primary-plan">
      <p class=" text-number"> US $750 </p>
    </div>
    <div class="plan-full-info-box standard-plan">
      <p class=" text-number"> US $750 </p>
    </div>
    <div class="plan-full-info-box light-plan">
      <p class=" text-number"> US $750 </p>
    </div>
  </div>
  <div class="plan-full-info-row">
    <div class="plan-full-info-box basic-plan">
      <p>Pruebas de diagnóstico y procedimientos requeridos por una emergencia.</p>
    </div>
    <div class="plan-full-info-box primary-plan">
      <p >100%</p>
    </div>
    <div class="plan-full-info-box standard-plan">
      <p >100%</p>
    </div>
    <div class="plan-full-info-box light-plan">
      <p >100%</p>
    </div>
  </div>
  <div class="plan-full-info-row">
    <div class="plan-full-info-box basic-plan">
      <p>Emergencia dental</p>
    </div>
    <div class="plan-full-info-box primary-plan">
      <p class="text-bold  text-number"> US $750 </p>
    </div>
    <div class="plan-full-info-box standard-plan">
      <p class="text-bold  text-number"> US $750 </p>
    </div>
    <div class="plan-full-info-box light-plan">
      <p class="text-bold  text-number"> US $750 </p>
    </div>
  </div>
  <div class="blue-stripe">
    <p>Servicios de Asistencia por Emergencia Médica</p>
  </div>
  <div class="plan-full-info-row">
    <div class="plan-full-info-box basic-plan">
      <p>Traslado terrestre o aéreo por emergencia médica</p>
    </div>
    <div class="plan-full-info-box primary-plan">
      <p class="text-bold text-number">US $50,000</p>
    </div>
    <div class="plan-full-info-box standard-plan">
      <p class="text-bold text-number">US $50,000</p>
    </div>
    <div class="plan-full-info-box light-plan">
      <p class="text-bold text-number">US $50,000</p>
    </div>
  </div>
  <div class="plan-full-info-row">
    <div class="plan-full-info-box basic-plan">
      <p>Repatriación por emergencia médica.</p>
    </div>
    <div class="plan-full-info-box primary-plan">
      <p class="text-bold text-number">US $50,000</p>
    </div>
    <div class="plan-full-info-box standard-plan">
      <p class="text-bold text-number">US $50,000</p>
    </div>
    <div class="plan-full-info-box light-plan">
      <p class="text-bold text-number">US $50,000</p>
    </div>
  </div>
  <div class="plan-full-info-row">
    <div class="plan-full-info-box basic-plan">
      <p>Estadía en hotel por convalecencia prescrita resultante de una emergencia.</p>
    </div>
    <div class="plan-full-info-box primary-plan">
      <p >US $100 por día, máximo 10 días</p>
    </div>
    <div class="plan-full-info-box standard-plan">
      <p >US $100 por día, máximo 10 días</p>
    </div>
    <div class="plan-full-info-box light-plan">
      <p >US $100 por día, máximo 10 días</p>
    </div>
  </div>
  <div class="plan-full-info-row">
    <div class="plan-full-info-box basic-plan">
      <p>Estadía en hotel por una prueba positiva de Covid-19 en el extranjero</p>
    </div>
    <div class="plan-full-info-box primary-plan">
      <p >US $100 por día, máximo 14 días</p>
    </div>
    <div class="plan-full-info-box standard-plan">
      <p >US $100 por día, máximo 14 días</p>
    </div>
    <div class="plan-full-info-box light-plan">
      <p >US $100 por día, máximo 14 días</p>
    </div>
  </div>
  <div class="plan-full-info-row">
    <div class="plan-full-info-box basic-plan">
      <p>Traslado de un (1) acompañante por hospitalización del Titular por más de 5 días resultado de una emergencia médica</p>
    </div>
    <div class="plan-full-info-box primary-plan">
      <p class="text-bold text-number"> US $1,000</p>
    </div>
    <div class="plan-full-info-box standard-plan">
      <p class="text-bold text-number"> US $1,000</p>
    </div>
    <div class="plan-full-info-box light-plan">
      <p class="text-bold text-number">US $1,000</p>
    </div>
  </div>
  <div class="plan-full-info-row">
    <div class="plan-full-info-box basic-plan">
      <p>Estadía en hotel para un acompañante</p>
    </div>
    <div class="plan-full-info-box primary-plan">
      <p >US $100 por día, máximo 10 días</p>
    </div>
    <div class="plan-full-info-box standard-plan">
      <p >US $100 por día, máximo 10 días</p>
    </div>
    <div class="plan-full-info-box light-plan">
      <p >US $100 por día, máximo 10 días</p>
    </div>
  </div>
  <div class="plan-full-info-row">
    <div class="plan-full-info-box basic-plan">
      <p>Garantía de regreso (en fecha diferente a la programada)</p>
    </div>
    <div class="plan-full-info-box primary-plan">
      <p >US $500 – diferencia en el costo del pasaje o penalidad impuesta</p>
    </div>
    <div class="plan-full-info-box standard-plan">
      <p >US $500 – diferencia en el costo del pasaje o penalidad impuesta</p>
    </div>
    <div class="plan-full-info-box light-plan">
      <p >US $500 – diferencia en el costo del pasaje o penalidad impuesta</p>
    </div>
  </div>
  <div class="plan-full-info-row">
    <div class="plan-full-info-box basic-plan">
      <p>Regreso retrasado por Covid-19</p>
    </div>
    <div class="plan-full-info-box primary-plan">
      <p > US $300 – diferencia o penalidad impuesta por el transportista</p>
    </div>
    <div class="plan-full-info-box standard-plan">
      <p > US $300 – diferencia o penalidad impuesta por el transportista</p>
    </div>
    <div class="plan-full-info-box light-plan">
      <p > US $300 – diferencia o penalidad impuesta por el transportista</p>
    </div>
  </div>
  <div class="plan-full-info-row">
    <div class="plan-full-info-box basic-plan">
      <p>Regreso de menores de 15 años o adultos mayores de 75 años</p>
    </div>
    <div class="plan-full-info-box primary-plan">
      <p class="text-bold text-number"> US $5,000</p>
    </div>
    <div class="plan-full-info-box standard-plan">
      <p class="text-bold text-number">US $5,000</p>
    </div>
    <div class="plan-full-info-box light-plan">
      <p class="text-bold text-number">US $5,000</p>
    </div>
  </div>
  <div class="plan-full-info-row">
    <div class="plan-full-info-box basic-plan">
      <p>Repatriación Funeraria</p>
    </div>
    <div class="plan-full-info-box primary-plan">
      <p class="text-bold text-number"> US $35,000</p>
    </div>
    <div class="plan-full-info-box standard-plan">
      <p class="text-bold text-number">US $35,000</p>
    </div>
    <div class="plan-full-info-box light-plan">
      <p class="text-bold text-number">US $35,000</p>
    </div>
  </div>
  <div class="plan-full-info-row">
    <div class="plan-full-info-box basic-plan">
      <p>Asistencia legal</p>
    </div>
    <div class="plan-full-info-box primary-plan">
      <p class="text-bold text-number"> US $1,500</p>
    </div>
    <div class="plan-full-info-box standard-plan">
      <p class="text-bold text-number">US $1,500</p>
    </div>
    <div class="plan-full-info-box light-plan">
      <p class="text-bold text-number">US $1,500</p>
    </div>
  </div>
  <div class="plan-full-info-row">
    <div class="plan-full-info-box basic-plan">
      <p>Gastos por fianza</p>
    </div>
    <div class="plan-full-info-box primary-plan">
      <p class="text-bold text-number">US $1,500</p>
    </div>
    <div class="plan-full-info-box standard-plan">
      <p class="text-bold text-number">US $1,500</p>
    </div>
    <div class="plan-full-info-box light-plan">
      <p class="text-bold text-number">US $1,500</p>
    </div>
  </div>
  <div class="plan-full-info-row">
    <div class="plan-full-info-box basic-plan">
      <p>Servicio de remolque para vehículo alquilado</p>
    </div>
    <div class="plan-full-info-box primary-plan">
      <p class="text-bold text-number"> US $100</p>
    </div>
    <div class="plan-full-info-box standard-plan">
      <p class="text-bold text-number">US $100</p>
    </div>
    <div class="plan-full-info-box light-plan">
      <p class="text-bold text-number">US $100</p>
    </div>
  </div>
  <div class="plan-full-info-row">
    <div class="plan-full-info-box basic-plan">
      <p>Viaje demorado o cancelado por mas de seis (6) horas consecutivas</p>
    </div>
    <div class="plan-full-info-box primary-plan">
      <p class="text-bold text-number">US $300</p>
    </div>
    <div class="plan-full-info-box standard-plan">
      <p class="text-bold text-number">US $300</p>
    </div>
    <div class="plan-full-info-box light-plan">
      <p class="text-bold text-number">US $300</p>
    </div>
  </div>
  <div class="plan-full-info-row">
    <div class="plan-full-info-box basic-plan">
      <p>Localización de equipaje</p>
    </div>
    <div class="plan-full-info-box primary-plan">
      <p>Llamada de asistencia</p>
    </div>
    <div class="plan-full-info-box standard-plan">
      <p>Llamada de asistencia</p>
    </div>
    <div class="plan-full-info-box light-plan">
      <p>Llamada de asistencia</p>
    </div>
  </div>
  <div class="plan-full-info-row">
    <div class="plan-full-info-box basic-plan">
      <p>Demora de equipaje por más de 24 horas</p>
    </div>
    <div class="plan-full-info-box primary-plan">
      <p class="text-bold text-number"> US $200</p>
    </div>
    <div class="plan-full-info-box standard-plan">
      <p class="text-bold text-number"> US $200</p>
    </div>
    <div class="plan-full-info-box light-plan">
      <p class="text-bold text-number">US $500</p>
    </div>
  </div>
  <div class="plan-full-info-row">
    <div class="plan-full-info-box basic-plan">
      <p>Pérdida definitiva del equipaje a partir de los 10 días</p>
    </div>
    <div class="plan-full-info-box primary-plan">
      <p >$20 por kilogramo de peso del equipaje, 
        hasta US $1,000</p>
    </div>
    <div class="plan-full-info-box standard-plan">
      <p >$20 por kilogramo de peso del equipaje, 
        hasta US $1,000</p>
    </div>
    <div class="plan-full-info-box light-plan">
      <p >$40 por kilogramo de peso del equipaje, 
        hasta US $2,000</p>
    </div>
  </div>
  <div class="plan-full-info-row">
    <div class="plan-full-info-box basic-plan">
      <p>Pérdida de vuelo de conexión aérea por más de seis (6) horas consecutivas</p>
    </div>
    <div class="plan-full-info-box primary-plan">
      <p class=" text-number"> US $150</p>
    </div>
    <div class="plan-full-info-box standard-plan">
      <p class=" text-number"> US $150</p>
    </div>
    <div class="plan-full-info-box light-plan">
      <p class=" text-number"> US $150</p>
    </div>
  </div>
  <div class="plan-full-info-row">
    <div class="plan-full-info-box basic-plan">
      <p>Pérdida de pasaporte</p>
    </div>
    <div class="plan-full-info-box primary-plan">
      <p>US $500‐Gestión Consular</p>
    </div>
    <div class="plan-full-info-box standard-plan">
      <p>US $500‐Gestión Consular</p>
    </div>
    <div class="plan-full-info-box light-plan">
      <p>US $500‐Gestión Consular</p>
    </div>
  </div>
  <div class="plan-full-info-row">
    <div class="plan-full-info-box basic-plan">
      <p>Regreso por fallecimiento de un familiar inmediato</p>
    </div>
    <div class="plan-full-info-box primary-plan">
      <p>US $500 – diferencia en el costo del pasaje o penalidad impuesta</p>
    </div>
    <div class="plan-full-info-box standard-plan">
      <p>US $500 – diferencia en el costo del pasaje o penalidad impuesta</p>
    </div>
    <div class="plan-full-info-box light-plan">
      <p>US $500 – diferencia en el costo del pasaje o penalidad impuesta</p>
    </div>
  </div>
  <div class="plan-full-info-row">
    <div class="plan-full-info-box basic-plan">
      <p>Regreso por pérdida catastrófica en su domicilio</p>
    </div>
    <div class="plan-full-info-box primary-plan">
      <p>US $500 ‐ diferencia en el costo del pasaje o penalidad impuesta</p>
    </div>
    <div class="plan-full-info-box standard-plan">
      <p>US $500 ‐ diferencia en el costo del pasaje o penalidad impuesta</p>
    </div>
    <div class="plan-full-info-box light-plan">
      <p>US $500 ‐ diferencia en el costo del pasaje o penalidad impuesta</p>
    </div>
  </div>
  <div class="blue-stripe">
    <p>Beneficios Opcionales</p>
  </div>
  <div class="gray-stripe">
    <p>Los siguientes beneficios sólo serán provistos si la prima adicional ha sido pagada, la cantidad límite se indica a continuación y el beneficio se especifica en el Certificado emitido por la Compañía</p>
  </div>
  <div class="plan-full-info-row">
    <div class="plan-full-info-box basic-plan">
      <p>Condiciones médicas preexistente</p>
    </div>
    <div class="plan-full-info-box primary-plan">
      <p>Límite máximo: 30% de la cobertura máxima seleccionada bajo el plan, sin exceder US $30.000
        <span class="blue-text">Incluido: {{planPrimary.preexistingMedicalConditions.value == true ? 'Si' : 'No'}}</span>
        </p>
    </div>
    <div class="plan-full-info-box standard-plan">
      <p>Límite máximo: 30% de la cobertura máxima seleccionada bajo el plan, sin exceder US $30.000
        <span class="blue-text">Incluido: {{planPrimary.preexistingMedicalConditions.value == true ? 'Si' : 'No'}}</span></p>
    </div>
    <div class="plan-full-info-box light-plan">
      <p>Límite máximo: 30% de la cobertura máxima seleccionada bajo el plan, sin exceder US $30.000
        <span class="blue-text">Incluido: {{planPrimary.preexistingMedicalConditions.value == true ? 'Si' : 'No'}}</span></p>
    </div>
  </div>
  <div class="plan-full-info-row">
    <div class="plan-full-info-box basic-plan">
      <p>Deportes Peligrosos, Profesionales y Amateur</p>
    </div>
    <div class="plan-full-info-box primary-plan">
      <p>Servicios de asistencia médica para la estabilización y tratamiento de una emergencia médica por accidente
        resultado de su participación en deportes peligrosos, profesionales o amateur. El límite de este beneficio será la cobertura máxima seleccionada, sin exceder US $100,000.<br/>
        Edad máxima 65 años.
         <span class="blue-text">Incluido: {{planPrimary.sportPractice.value == true ? 'Si' : 'No'}}</span></p>
    </div>
    <div class="plan-full-info-box standard-plan">
      <p>Servicios de asistencia médica para la estabilización y tratamiento de una emergencia médica por accidente
        resultado de su participación en deportes peligrosos, profesionales o amateur. El límite de este beneficio será la cobertura máxima seleccionada, sin exceder US $100,000.<br/>
        Edad máxima 65 años. <span class="blue-text">Incluido: {{planPrimary.sportPractice.value == true ? 'Si' : 'No'}}</span></p>
    </div>
    <div class="plan-full-info-box light-plan">
      <p>Servicios de asistencia médica para la estabilización y tratamiento de una emergencia médica por accidente
        resultado de su participación en deportes peligrosos, profesionales o amateur. El límite de este beneficio será la cobertura máxima seleccionada, sin exceder US $100,000.<br/>
        Edad máxima 65 años. <span class="blue-text">Incluido: {{planPrimary.sportPractice.value == true ? 'Si' : 'No'}}</span></p>
    </div>
  </div>
  <div class="plan-full-info-row">
    <div class="plan-full-info-box basic-plan">
      <p>Cancelación e interrupción de viaje</p>
    </div>
    <div class="plan-full-info-box primary-plan">
      <p>Indemnización por la pérdida de los gastos prepagados, no reembolsables, en relación con una cancelación o interrupción inevitable del viaje por una causa cubierta. Límite máximo: US $2,500.
        <span class="blue-text">Incluido: {{planPrimary.cancellationDueToCatastrophicTrip.rate != 0 ? 'Si' : 'No'}}</span>
      </p>
    </div>
    <div class="plan-full-info-box standard-plan">
      <p>Indemnización por la pérdida de los gastos prepagados, no reembolsables, en relación con una cancelación o interrupción inevitable del viaje por una causa cubierta. Límite máximo: US $2,500.
        <span class="blue-text">Incluido: {{planStandard.cancellationDueToCatastrophicTrip.rate != 0 ? 'Si' : 'No'}}</span>
      </p>
    </div>
    <div class="plan-full-info-box light-plan">
      <p>Indemnización por la pérdida de los gastos prepagados, no reembolsables, en relación con una cancelación o interrupción inevitable del viaje por una causa cubierta. Límite máximo: US $2,500.
        <span class="blue-text">Incluido: {{planLight.cancellationDueToCatastrophicTrip.rate != 0 ? 'Si' : 'No'}}</span>
      </p>
    </div>
  </div>
  <div class="plan-full-info-row">
    <div class="plan-full-info-box basic-plan">
      <p>Futura mamá</p>
    </div>
    <div class="plan-full-info-box primary-plan">
      <p>Servicios de asistencia médica para la estabilización de una emergencia médica por enfermedad o accidente producto de su embarazo. Beneficio se adquiere entre 12 y 32 semanas de embarazo y cuando la edad de la solicitante sea entre 18 y 40 años.<br/>
        Límite Máximo: Hasta US $10.000
        <span class="blue-text">Seleccionado: {{planPrimary.futureMom.value == true ? 'Si' : 'No'}}</span></p>
    </div>
    <div class="plan-full-info-box standard-plan">
      <p>Servicios de asistencia médica para la estabilización de una emergencia médica por enfermedad o accidente producto de su embarazo. Beneficio se adquiere entre 12 y 32 semanas de embarazo y cuando la edad de la solicitante sea entre 18 y 40 años.<br/>
        Límite Máximo: Hasta US $10.000
        <span class="blue-text">Seleccionado: {{planStandard.futureMom.value == true ? 'Si' : 'No'}}</span></p>
    </div>
    <div class="plan-full-info-box light-plan">
      <p>Servicios de asistencia médica para la estabilización de una emergencia médica por enfermedad o accidente producto de su embarazo. Beneficio se adquiere entre 12 y 32 semanas de embarazo y cuando la edad de la solicitante sea entre 18 y 40 años.<br/>
        Límite Máximo: Hasta US $10.000
        <span class="blue-text">Seleccionado: {{planLight.futureMom.value == true ? 'Si' : 'No'}}</span></p>
    </div>
  </div>
  <div class="plan-full-info-row">
    <div class="plan-full-info-box basic-plan">
      <p>Asistencia para mascotas</p>
    </div>
    <div class="plan-full-info-box primary-plan">
      <p>Servicios de asistencia médica para la estabilización de una emergencia médica por enfermedad no preexistente o accidente de la mascota. Límite Máximo $1.000 por mascota. Máximo 3 (aplica para perros y gatos únicamente)
        <span class="blue-text">Incluido: {{planPrimary.pets.rate != 0 ? 'Si' : 'No'}}</span></p>
    </div>
    <div class="plan-full-info-box standard-plan">
      <p>Servicios de asistencia médica para la estabilización de una emergencia médica por enfermedad no preexistente o accidente de la mascota. Límite Máximo $1.000 por mascota. Máximo 3 (aplica para perros y gatos únicamente)
        <span class="blue-text">Incluido: {{planStandard.pets.rate != 0 ? 'Si' : 'No'}}</span></p>
    </div>
    <div class="plan-full-info-box light-plan">
      <p>Servicios de asistencia médica para la estabilización de una emergencia médica por enfermedad no preexistente o accidente de la mascota. Límite Máximo $1.000 por mascota. Máximo 3 (aplica para perros y gatos únicamente)
        <span class="blue-text">Incluido: {{planLight.pets.rate != 0 ? 'Si' : 'No'}}</span></p>
    </div>
  </div>
  <div class="plan-full-info-row">
    <div class="plan-full-info-box basic-plan">
      <p>Asistencia legal VIP</p>
    </div>
    <div class="plan-full-info-box primary-plan">
      <p>Asistencia legal presencial durante su viaje con apoyo local.<br/>
        Países aceptados:<br/>
Albania, Anguila, Arabia Saudita, Argentina, Australia, Austria, Bahamas, Barbados, Baréin, Bielorrusia, Bolivia, Bosnia y Herzegovina, Brasil, Bulgaria, Bélgica, Camerún, Canadá, Catar, Chile, China, Chipre, Colombia, Corea del Sur, Costa Rica, Costa de Marfil, Croacia, Dinamarca, Dominica, Ecuador, Egipto, El Salvador, Emiratos Árabes Unidos, Eslovaquia, Eslovenia, España, Estados Unidos, Estonia, Etiopía, Filipinas, Finlandia, Francia, Granada, Grecia, Guadalupe, Guatemala, Guyana, Haití, Honduras, Hungría, India, Indonesia, Inglaterra, Irak, Irlanda, Islandia, Islas Caimán, Israel, Italia, Jamaica, Japón, Kenia, Kuwait, Letonia, Liechtenstein, Lituania, Luxemburgo, Líbano, Macao, Madagascar, Malasia, Malaui, Maldivas, Malta, Marruecos, Martinica, Mauricio, Mayotte, Montenegro, México, Namibia, Nicaragua, Nigeria, Noruega, Nueva Caledonia, Nueva Zelanda, Omán, Panamá, Paraguay, Países Bajos, Perú, Polinesia Francesa, Polonia, Portugal, Puerto Rico, República Checa, República Dominicana, Ruanda, Rumanía, Rusia, Reunión, Saint Bartelemi, Saint Martin, San Cristóbal y Nieves, San Pedro y Miquelón, Serbia, Seychelles, Singapur, Sri Lanka, Sudáfrica, Suecia, Suiza, Tailandia, Trinidad y Tobago, Turquía, Túnez, Ucrania, Uganda, República Unida de Tanzania, Uruguay, Venezuela, Wallis y Futuna, Zambia, Zimbabue.
        <span class="blue-text">Incluido: {{planPrimary.legalVipAssistance.value == true ? 'Si' : 'No'}}</span>
      </p>
    </div>
    <div class="plan-full-info-box standard-plan">
      <p>Asistencia legal presencial durante su viaje con apoyo local.
        <br/>
        Países aceptados:<br/>
Albania, Anguila, Arabia Saudita, Argentina, Australia, Austria, Bahamas, Barbados, Baréin, Bielorrusia, Bolivia, Bosnia y Herzegovina, Brasil, Bulgaria, Bélgica, Camerún, Canadá, Catar, Chile, China, Chipre, Colombia, Corea del Sur, Costa Rica, Costa de Marfil, Croacia, Dinamarca, Dominica, Ecuador, Egipto, El Salvador, Emiratos Árabes Unidos, Eslovaquia, Eslovenia, España, Estados Unidos, Estonia, Etiopía, Filipinas, Finlandia, Francia, Granada, Grecia, Guadalupe, Guatemala, Guyana, Haití, Honduras, Hungría, India, Indonesia, Inglaterra, Irak, Irlanda, Islandia, Islas Caimán, Israel, Italia, Jamaica, Japón, Kenia, Kuwait, Letonia, Liechtenstein, Lituania, Luxemburgo, Líbano, Macao, Madagascar, Malasia, Malaui, Maldivas, Malta, Marruecos, Martinica, Mauricio, Mayotte, Montenegro, México, Namibia, Nicaragua, Nigeria, Noruega, Nueva Caledonia, Nueva Zelanda, Omán, Panamá, Paraguay, Países Bajos, Perú, Polinesia Francesa, Polonia, Portugal, Puerto Rico, República Checa, República Dominicana, Ruanda, Rumanía, Rusia, Reunión, Saint Bartelemi, Saint Martin, San Cristóbal y Nieves, San Pedro y Miquelón, Serbia, Seychelles, Singapur, Sri Lanka, Sudáfrica, Suecia, Suiza, Tailandia, Trinidad y Tobago, Turquía, Túnez, Ucrania, Uganda, República Unida de Tanzania, Uruguay, Venezuela, Wallis y Futuna, Zambia, Zimbabue.
        <span class="blue-text">Incluido: {{planPrimary.legalVipAssistance.value == true ? 'Si' : 'No'}}</span>
      </p>
    </div>
    <div class="plan-full-info-box light-plan">
      <p>Asistencia legal presencial durante su viaje con apoyo local.
        <br/>
        Países aceptados:<br/>
Albania, Anguila, Arabia Saudita, Argentina, Australia, Austria, Bahamas, Barbados, Baréin, Bielorrusia, Bolivia, Bosnia y Herzegovina, Brasil, Bulgaria, Bélgica, Camerún, Canadá, Catar, Chile, China, Chipre, Colombia, Corea del Sur, Costa Rica, Costa de Marfil, Croacia, Dinamarca, Dominica, Ecuador, Egipto, El Salvador, Emiratos Árabes Unidos, Eslovaquia, Eslovenia, España, Estados Unidos, Estonia, Etiopía, Filipinas, Finlandia, Francia, Granada, Grecia, Guadalupe, Guatemala, Guyana, Haití, Honduras, Hungría, India, Indonesia, Inglaterra, Irak, Irlanda, Islandia, Islas Caimán, Israel, Italia, Jamaica, Japón, Kenia, Kuwait, Letonia, Liechtenstein, Lituania, Luxemburgo, Líbano, Macao, Madagascar, Malasia, Malaui, Maldivas, Malta, Marruecos, Martinica, Mauricio, Mayotte, Montenegro, México, Namibia, Nicaragua, Nigeria, Noruega, Nueva Caledonia, Nueva Zelanda, Omán, Panamá, Paraguay, Países Bajos, Perú, Polinesia Francesa, Polonia, Portugal, Puerto Rico, República Checa, República Dominicana, Ruanda, Rumanía, Rusia, Reunión, Saint Bartelemi, Saint Martin, San Cristóbal y Nieves, San Pedro y Miquelón, Serbia, Seychelles, Singapur, Sri Lanka, Sudáfrica, Suecia, Suiza, Tailandia, Trinidad y Tobago, Turquía, Túnez, Ucrania, Uganda, República Unida de Tanzania, Uruguay, Venezuela, Wallis y Futuna, Zambia, Zimbabue.
        <span class="blue-text">Incluido: {{planPrimary.legalVipAssistance.value == true ? 'Si' : 'No'}}</span>
      </p>
    </div>
  </div>

</div>

<div class="modal fade" id="sendQuoteByEmailModal" tabindex="-1" aria-labelledby="sendQuoteByEmailModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered send-quote-modal">
    <div class="modal-content">
      <div class="modal-body ">
         <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
            <svg xmlns="http://www.w3.org/2000/svg" width="29" height="29" viewBox="0 0 29 29" fill="none">
  <path d="M14.4995 16.1911L8.57865 22.112C8.35712 22.3335 8.07517 22.4443 7.73281 22.4443C7.39045 22.4443 7.10851 22.3335 6.88698 22.112C6.66545 21.8905 6.55469 21.6085 6.55469 21.2661C6.55469 20.9238 6.66545 20.6418 6.88698 20.4203L12.8078 14.4995L6.88698 8.57865C6.66545 8.35712 6.55469 8.07517 6.55469 7.73281C6.55469 7.39045 6.66545 7.10851 6.88698 6.88698C7.10851 6.66545 7.39045 6.55469 7.73281 6.55469C8.07517 6.55469 8.35712 6.66545 8.57865 6.88698L14.4995 12.8078L20.4203 6.88698C20.6418 6.66545 20.9238 6.55469 21.2661 6.55469C21.6085 6.55469 21.8905 6.66545 22.112 6.88698C22.3335 7.10851 22.4443 7.39045 22.4443 7.73281C22.4443 8.07517 22.3335 8.35712 22.112 8.57865L16.1911 14.4995L22.112 20.4203C22.3335 20.6418 22.4443 20.9238 22.4443 21.2661C22.4443 21.6085 22.3335 21.8905 22.112 22.112C21.8905 22.3335 21.6085 22.4443 21.2661 22.4443C20.9238 22.4443 20.6418 22.3335 20.4203 22.112L14.4995 16.1911Z" fill="#2828E0"/>
</svg>
          </button>
        <div *ngIf="!emailSendingStatus || emailSendingStatus == 0">
         
          <h5 class="modal-title" id="exampleModalLabel">Envía tu cotización por correo</h5>
          
            <p>
              Puede ingresar varios correos electrónicos separados por coma (,) o punto y coma (;) 
            </p>
          
          <form [formGroup]="sendQuoteByEmailForm" class="form-general-style">
            <div class="form-group">
              <app-input-field [formGroup]="sendQuoteByEmailForm" controlName="optionalRecipients" id="optionalRecipients" label="Correo Electrónico"

                 errorMessage="Correo Electrónico requerido" ></app-input-field>
                <button type="button" [disabled]="canContinue!=true" class="btn btn-primary send-email-button" (click)="sendEmail()">Enviar</button>
              <!-- <label for="optionalRecipients" class="label-form-style">Emails</label>
              <input type="text" class="form-control input-form-full-space" formControlName="optionalRecipients" id="optionalRecipients" placeholder="Correo Electrónico"> -->
            </div>
          </form>
        </div>

        <div  *ngIf="emailSendingStatus == 1">
          <h5 class="modal-title" id="exampleModalLabel">Enviando Cotización</h5>

          <img src="/assets/img/loading_logo.gif" alt="Blue Assist" class="loading-logo">
        </div>

        <div  *ngIf="emailSendingStatus == 2">
          <h5 class="modal-title" id="exampleModalLabel">Cotización Enviada</h5>

          <img src="/assets/img/big-logo.png" alt="Blue Assist" class="loading-logo loading-active">
        </div>

        <div  *ngIf="emailSendingStatus == 3">
             <h5 class="modal-title" id="exampleModalLabel">Error al Enviar la Cotización </h5>
            <div class="alert alert-danger" role="alert" style="margin-top: 20px;">
              <strong>Correo no enviado.</strong> Por favor, intente nuevamente más tarde.
            </div>
         
        </div>

      </div>
      
    </div>
  </div>
</div> 
<!-- <button type="button" [disabled]="isBusy" class="btn btn-primary" data-bs-toggle="modal"
        data-bs-target="#sendQuoteDownloadModal">Enviar Correo</button>
<div class="modal fade" id="sendQuoteDownloadModal" tabindex="-1" aria-labelledby="sendQuoteDownloadModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Enviar cotización por email</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <h2>Un momento, por favor</h2>
        <h2>Correo Enviado</h2>
        <img src="/assets/img/logo-image.svg" alt="Logo" class="logo" />
      </div>
    </div>
  </div>
</div> -->

<!-- Flecha fija al pie del viewport (escritorio/tableta): invita a bajar hasta las coberturas opcionales; desaparece al hacer scroll -->
<button type="button" class="scroll-hint" *ngIf="showScrollHint" (click)="scrollToOptions()" aria-label="Ver las coberturas opcionales"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg></button>
